export const saleFr = {
  "Numero": "Numero",
  "Client": "Client",
  "Total": "Total",

  "Prix": "Prix",
  "Prix de vente": "Prix de vente",
  "Quantité": "Quantité",
  "Donner le prix de vente": "Donner le prix de vente",
  "Donner la quantité": "Donner la quantité",
  "Choisir un client": "Choisir un client",
  "Nom du produit": "Nom du produit",
  "Montant": "Montant",
  "Montant que voulez vous payer": "Montant que voulez vous payer",
  
  "Produit": "Produit",
  "Prix.Unitaire * Quantite": "Prix.Unitaire * Quantite",
  "Chercher un bon de vente": "Chercher une facture de vente",

  "Chercher un service": "Chercher un service",
  "Description": "Description",  

  "Chercher une sevice": "Chercher une sevice",
  "Service": "Service",

  "Capital Social": "Capital Social",
  "Benefices": "Benefices",
  "Pertes": "Pertes",
  
}